import React from 'react';
import { Icon, Message, Button, Modal, Header } from 'semantic-ui-react'
import _ from 'lodash';

const Autorizac = ({elemento, handleChange}) => {
  return(
    <tr className=''>
      <td className='collapsing'>
        <div className='ui fitted slider checkbox'>
          <input type='checkbox' name='estadoAut' id={elemento.codigoAutorizac} checked={elemento.estadoAut} onChange={(ev)=>handleChange(ev, elemento)}/>
          <label />
        </div>
      </td>
      <td className=''>{elemento.codigoAutorizac}</td>
      <td className=''>{elemento.descrAutorizac}</td>
    </tr>
  )
};

const ListaAut = ({list, handleChange}) => {
  const nivel1Detalle = list.map((elemento, _id) => <Autorizac elemento={elemento} handleChange={handleChange} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//

const AutPerfil = ({elemento, handleChange}) => {
  return(
    <tr className=''>
      <td className='collapsing'>
        <div className='ui fitted slider checkbox'>
          <input type='checkbox' name='estadoAutOfer' id={elemento.codigoAutorizac} checked={elemento.estadoAut} onChange={(ev)=>handleChange(ev, elemento)}/>
          <label />
        </div>
      </td>
      <td className=''>{elemento.codigoAutorizac}</td>
      <td className=''>{elemento.descrAutorizac}</td>
    </tr>
  )
};

const ListaAutPerfil = ({list, handleChange}) => {
  const nivel1Detalle = list.map((elemento, _id) => <AutPerfil elemento={elemento} handleChange={handleChange} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//

class UserAutP2 extends React.Component {
  state={
      listAut: this.props.lisAut,
      listAutPerfil: this.props.lisAutPerfil,
      errors: this.props.errors,
      open: false,
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }

  handleRefresh = () => {
    let arrayAutTar=this.state.listAutPerfil
    let arrayAut=this.state.listAut

    arrayAut.forEach((elemento, _id) => {
      if(elemento.estadoAut===true){
          arrayAutTar.push({codigoAutorizac: elemento.codigoAutorizac, descrAutorizac: elemento.descrAutorizac,
            _id: elemento._id, estadoAut: true});
          }
    })

    let arrayAut1 = arrayAut.filter(item => item.estadoAut===true);
    arrayAut1.forEach((elemento1, _id) => {
      arrayAut.forEach((elemento, _id) => {
        if(elemento.estadoAut===true && elemento1.codigoAutorizac===elemento.codigoAutorizac){
          const indexAut = arrayAut.findIndex( autorizac => autorizac.codigoAutorizac === elemento.codigoAutorizac );
          arrayAut.splice(indexAut, 1);
        }
      })
    })

    arrayAutTar.forEach((elemento, _id) => {
      if(elemento.estadoAut===false){
          arrayAut.push({codigoAutorizac: elemento.codigoAutorizac, descrAutorizac: elemento.descrAutorizac,
            _id: elemento._id, estadoAut: false});
          }
    })
    
    arrayAut1 = arrayAutTar.filter(item => item.estadoAut===false);
    arrayAut1.forEach((elemento1, _id) => {
      arrayAutTar.forEach((elemento, _id) => {
        if(elemento.estadoAut===false && elemento1.codigoAutorizac===elemento.codigoAutorizac){
          const indexAut = arrayAutTar.findIndex( autorizac => autorizac.codigoAutorizac === elemento.codigoAutorizac );
          arrayAutTar.splice(indexAut, 1);
        }
      })
    })

    arrayAutTar = _.orderBy(arrayAutTar, ['codigoAutorizac'])
    arrayAut = _.orderBy(arrayAut, ['codigoAutorizac'])

    // this.ordenarArrayAsc(arrayAutTar, 'descrClaseServ')
    // this.ordenarArrayAsc(arrayAut, 'descrClaseServ')

    this.setState({listAutPerfil: arrayAutTar})
    this.setState({listAut: arrayAut})
    this.setState({open: false})
    this.setState({errors: []})
  }

  handleChange = (ev, elemento) => {
    if(ev.target.name === "estadoAutOfer"){
      let listAutPerfil=this.state.listAutPerfil
      const indexAut = listAutPerfil.findIndex( autorizac => autorizac.codigoAutorizac === ev.target.id );
      if(elemento.estadoAut===false){
        listAutPerfil[indexAut].estadoAut = true
      }else{
        listAutPerfil[indexAut].estadoAut = false
      }

      this.setState({listAutPerfil});
    }

    if(ev.target.name === "estadoAut"){
      let listAut=this.state.listAut
      const indexAut = listAut.findIndex( autorizac => autorizac.codigoAutorizac === ev.target.id );
      if(elemento.estadoAut===false){
        listAut[indexAut].estadoAut = true
      }else{
        listAut[indexAut].estadoAut = false
      }
      this.setState({listAut});
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel"){this.setState({open: true})};

    if(btnPress==="No"){
        this.setState({open: false})
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps){

    if(this.props.lisAut!==nextProps.lisAut){
        this.setState({listAut: this.props.lisAutIni})
        this.setState({listAutPerfil: this.props.lisAutPerfilIni})
    }
    if(this.props.errors!==nextProps.errors){
      this.setState({errors: nextProps.errors})
    }
    this.setState({open: false})
  }

  shouldComponentUpdate(nextProps, nextState){
    if(this.props.lisAut!==nextProps.lisAut || this.state.listAut!==nextState.lisAut){
      return true
    }else{
      return false
    }
  }

  UNSAFE_componentWillUpdate(nextProps){
//entra si shouldComponentUpdate return true

}

  render(){
    const {listAut, listAutPerfil, errors, open} = this.state;

    const a20051501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "20051501" );

    // console.log(this.state)
    // console.log(this.props)
    // console.log(listAut)
    // console.log(listAutPerfil)
    return(
      <div>
        <Modal open={open} size="tiny" style={this.props.styles.modal} trigger={
          <div>
            <Button className='ui right labeled icon button' style={this.props.styles.titBuscar}>
                <i className='large hand point down yellow icon'></i>
                Perfil: {this.props.perfil}
            </Button>
            <Button name="btnRefr" id="btnRefr"  className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.handleRefresh}>
                <i className='large redo yellow icon'></i>
                Refrescar
            </Button>
            <Button name="btnVrInic" id="btnVrInic" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.props.handleVrinic}>
                <i className='large refresh yellow icon'></i>
                Valores iniciales
            </Button>
            {a20051501!==-1 &&
            <Button name="btnUpdDel" id="btnUpdDel" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                <i className='large save yellow icon'></i>
                Guardar
            </Button>
            }
          </div>
        }>
 
          <Header icon='edit' color='red' content='Modificar perfil' />
      
          <Modal.Content>
              <p>Esta usted seguro ?</p>
          </Modal.Content>
          <Modal.Actions>
              <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                  <Icon dato1="No" name='remove' /> No
              </Button>
              <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>this.props.handleSubmit(ev, listAutPerfil)}>
                  <Icon dato1="Si" name='checkmark' /> Si
              </Button>
          </Modal.Actions>
        </Modal>

        {
            errors.length?<Message negative header="Los siguientes errores:"
            list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
        }

      <div style={this.props.styles.box}>
        <div className='ui blue inverted raised segment'>
          <a className='ui large label' style={this.props.styles.styTableSup}>Autorizaciones asignadas al perfil</a>
          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className=''></th>
                <th className=''>Código autorización</th>
                <th className=''>Descripción autorización</th>
              </tr>
            </thead>
            <ListaAutPerfil list={listAutPerfil} handleChange={this.handleChange}/>
          </table>
        </div>

        <div className='ui blue inverted raised segment'>
          <a className='ui large label' style={this.props.styles.styTableInf}>Autorizaciones sin asignar al perfil</a>
          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
            <thead className=''>
              <tr className=''>
                <th className=''></th>
                <th className=''>Código autorización</th>
                <th className=''>Descripción autorización</th>
              </tr>
            </thead>
            <ListaAut list={listAut} handleChange={this.handleChange}/>
          </table>
        </div>
      </div>
      </div>
    )
  }
}

export default UserAutP2